export const addMinutes = (minutes, date) => {
    const daysToAdd = Math.floor(minutes / 1440)
    const minutesAfterDays = minutes - daysToAdd * 24 * 60
    const hoursToAdd = Math.floor(minutesAfterDays / 60)
    const minutesToAdd = minutesAfterDays - hoursToAdd * 60
    let result = new Date(date)
    result.setDate(result.getDate() + daysToAdd)
    result.setHours(result.getHours() + hoursToAdd)
    result.setMinutes(result.getMinutes() + minutesToAdd)
    return result
}
